import { createFileRoute, Outlet } from '@tanstack/react-router';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { useTenantFeatureFlags } from '@/lib/hooks/use-tenant-feature-flags';
import { WorkReports } from '@/pages/work-reports';
import { WorkReportPanelHost } from '@/pages/work-reports/detail/work-report-panel-host';
import { PROTECTED, WORK_REPORTS } from '@/lib/constants/routes';
import z from '@/lib/zod';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from '@/lib/zod-search-params';
import { isMineOn } from '@/pages/work-reports/lib/filter-chips';

export const workReportsSearchSchema = commonSearchSchema.extend({
  tab: z.string().nullish(),
  commessaId: optionalSearchString(),
  companyId: optionalSearchString(),
  contractId: optionalSearchString(),
  technicianId: optionalSearchString(),
  /**
   * «I miei»: booleano, presente solo acceso; un altro valore vale assente.
   * La stringa `'true'` dei link scritti prima vale ancora acceso.
   */
  mine: z.preprocess(
    (value) => (isMineOn(value) ? true : value),
    optionalSearchBoolean()
  ),
  billingState: optionalSearchString(),
  /** Pannello Filtri: periodo sulla data del rapportino (nomi dell'API). */
  dateFrom: optionalSearchString(),
  dateTo: optionalSearchString(),
});

export const Route = createFileRoute('/protected/_layout/work-reports/_layout')(
  {
    validateSearch: workReportsSearchSchema,
    component: WorkReportsLayout,
  }
);

/** Sezione visibile con il permesso E il feature flag del tenant. */
function WorkReportsLayout() {
  const { canAccessWorkReports, isLoading } = usePermissions();
  const { isWorkReportsEnabled, isLoading: isLoadingFlags } =
    useTenantFeatureFlags();
  return (
    <RoleGuard
      hasAccess={canAccessWorkReports && isWorkReportsEnabled}
      isLoading={isLoading || isLoadingFlags}
    >
      <WorkReports />
      <Outlet />
      <WorkReportPanelHost returnUrl={`${PROTECTED}${WORK_REPORTS}`} />
    </RoleGuard>
  );
}
